import { get } from "../util/utilFunc";

const buildQuery = (params) => {
  const query = Object.entries(params)
    .filter(([, value]) => value !== null && value !== undefined && value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  return query ? `?${query}` : "";
};

export const fetchVoicemailStats = async (officeId, from, to) => {
  try {
    const query = buildQuery({ officeId, from, to });
    const res = await get(`/voicemail-notifications/stats${query}`, {}, {});
    return res;
  } catch (error) {
    console.log(error);
    return { result: 1 };
  }
};

export const fetchVoicemailNotificationLogs = async ({
  officeId,
  status,
  from,
  to,
  page = 1,
  limit = 15,
}) => {
  try {
    const query = buildQuery({ officeId, status, from, to, page, limit });
    const res = await get(`/voicemail-notifications${query}`, {}, {});
    return res;
  } catch (error) {
    console.log(error);
    return { result: 1 };
  }
};
